import script from "./InternalBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./InternalBoard.vue?vue&type=script&setup=true&lang=js"

import "./InternalBoard.vue?vue&type=style&index=0&id=05e70c34&lang=scss"

const __exports__ = script;

export default __exports__